import {useState} from 'react';
import {EmployeeLayout} from '../EmployeeLayout/EmployeeLayout';
import style from './Profile.module.css';
import '../../../index.css'
import {BrowserRouter, NavLink, Route} from "react-router-dom";
import Resume from "./Resume";
import AccountData from './AccountData';
import {useSelector} from "react-redux";

const Profile: any = () => {
    const state: any = useSelector(state => state)
    const [profileimgUrl, setprofileimgUrl] = useState<string>(state.user.picture)
    const [changeimg, setchangeimg] = useState<boolean>(false)
    const [error, seterror] = useState<string>()
    const [Img, setImg] = useState<File>();

    function HandleChangeImg(data: any) {
        if(data.target.files && data.target.files[0].size / 1024 / 1024 < 2.9 && (data.target.files[0].type === "image/png" || data.target.files[0].type === "image/jpg")) {
            setprofileimgUrl(URL.createObjectURL(data.target.files[0]))
            setImg(data.target.files[0]);
            setchangeimg(true)
            seterror("")
        } else {
            seterror("يجب أن تكون الصورة الشخصية بتنسيق png أو jpg بحجم أقل من 3 ميجا")
        }
    }

    const [edit, setedit] = useState<boolean>(false);
    return (<>
        <EmployeeLayout>
            <div className='container rtl h-100 py-3'>
                <div className={'d-flex flex-column align-items-center justify-content-center my-3'}>
                    <div className={style.ProfileImg}>
                        <img className={style.ImgProfile} src={profileimgUrl} alt={state.user.name}/>

                        {edit ? (<>
                            <label htmlFor={'ProfileImg'} className={style.LabelImg}>
                                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="35" height="35" x="0" y="0"
                                     viewBox="0 0 32 32"
                                     className="">
                                    <g>
                                        <g xmlns="http://www.w3.org/2000/svg" id="_34-Add-image"
                                           data-name="34-Add-image">
                                            <path d="m29 24h-3v-3a1 1 0 0 0 -2 0v3h-3a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2z"
                                                  fill="white" data-original="#000000" className=""></path>
                                            <path
                                                    d="m17 24h-12a1 1 0 0 1 -1-1v-18a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 0 2 0v-12a3 3 0 0 0 -3-3h-18a3 3 0 0 0 -3 3v18a3 3 0 0 0 3 3h12a1 1 0 0 0 0-2z"
                                                    fill="white" data-original="white"></path>
                                            <circle cx="11" cy="8.5" r="2.5"
                                                    fill="white" data-original="white"></circle>
                                            <path
                                                    d="m7.29 14.29-1.29 1.3v6.41h16v-6.41l-4.29-4.3a1 1 0 0 0 -1.42 0l-5.29 5.3-2.29-2.3a1 1 0 0 0 -1.42 0z"
                                                    fill="white" data-original="white"></path>
                                        </g>
                                    </g>
                                </svg>
                            </label>
                            <input id={'ProfileImg'} onChange={HandleChangeImg} type={"file"}
                                   accept={'image/png,image/jpg'} className={style.hide}/>
                        </>) : ("")}

                    </div>
                    {error ? (<p className={style.errimg}>{error}</p>) : ""}
                    <h3 className={'text-white mt-2'}>{state.user.name}</h3>
                </div>
                <BrowserRouter>
                    <div className={'d-flex justify-content-center'}>
                        <NavLink to='/employee/profile' exact className={style.navlink}
                                 activeClassName={style.navlinkActive}>السيرة الذاتية</NavLink>
                        <NavLink to='/employee/profile/info'
                                 isActive={(match) => {
                                     if(match) {
                                         setedit(true)
                                         return true;
                                     } else {
                                         setedit(false)
                                         return false;
                                     }
                                 }} exact className={style.navlink} activeClassName={style.navlinkActive}>البيانات
                            الشخصيه</NavLink>
                    </div>
                    <div className={'pb25px px-3'}>

                        <Route path='/employee/profile' exact component={Resume}/>
                        <Route path='/employee/profile/info' exact
                               render={() => <AccountData Img={Img} changeimg={changeimg} setchangeimg={() => {
                                   setchangeimg(false)
                               }}/>}/>

                    </div>
                </BrowserRouter>
            </div>
        </EmployeeLayout>


    </>)
}
export default Profile;